import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, RouteReuseStrategy, withComponentInputBinding } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular';

import { AuthService } from '@core/store';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    /** setupIonicReact({ mode: "md", animated: false }) */
    provideIonicAngular({ mode: 'md', animated: false }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideRouter(routes, withComponentInputBinding()),
    /**
     * Bootstrap awaits this, so token/user are populated before any guard
     * runs. Removes the need for React's `hydrated` flag, which gated the
     * router on the literal string "Loading...".
     */
    provideAppInitializer(() => inject(AuthService).initAuth()),
  ],
};
